import React from "react";
import { Container, Card } from "react-bootstrap";

const sections = [
  {
    heading: "Overview",
    body: [
      'This Privacy Policy explains how Rentalo ("we", "our", or "us") collects, uses, and protects your information when you use our services, including our website, mobile applications, APIs, and other online offerings (collectively, the "Services").',
      "By accessing or using the Services, you agree to the collection and use of information in accordance with this Policy. If you do not agree, please discontinue use of the Services.",
    ],
  },
  {
    heading: "Information We Collect",
    body: [
      "Account Information: When you create or update an account, we collect details such as your name, email address, phone number, password, and location information (city and state).",
      "Listing & Transaction Data: When you post listings, register as a worker, or engage in transactions, we collect the data you submit, including descriptions, prices, images, and any communication related to the listing.",
      "Usage Information: We collect information about how you access and interact with the Services, including IP address, browser type, device identifiers, pages visited, and referring URLs.",
      "Communications: If you contact us or interact with other users through chats or messages, we collect the content of those communications.",
    ],
  },
  {
    heading: "How We Use Your Information",
    body: [
      "To provide, maintain, and improve the Services, including facilitating transactions, managing listings, and verifying user phone numbers via OTP.",
      "To personalize your experience, including showing relevant listings and worker profiles based on your location and preferences.",
      "To communicate with you, including sending service updates, transactional messages, security alerts, and marketing communications (where permitted by law).",
      "To detect, prevent, and respond to fraud, security breaches, or other malicious activity, and to enforce our Terms of Service.",
    ],
  },
  {
    heading: "Sharing Your Information",
    body: [
      "With other users when you participate in a transaction, chat, or respond to a listing. Your contact details may be shared with participants as necessary to complete service requests.",
      "With service providers who perform functions on our behalf, such as payment processing, SMS delivery (e.g., OTP via Twilio), email service providers, analytics, or hosting partners.",
      "With law enforcement or regulators when required by applicable law or to respond to legal process, protect our rights, or prevent harm.",
      "With your consent or at your direction, such as when you choose to share your information with a third party or integrate with other services.",
    ],
  },
  {
    heading: "Data Retention",
    body: [
      "We retain your information for as long as necessary to provide the Services, comply with legal obligations, resolve disputes, and enforce our agreements.",
      "If you close your account, we may retain certain information for backup, archival, and audit purposes, or as otherwise required by law.",
    ],
  },
  {
    heading: "Security",
    body: [
      "We implement reasonable technical, administrative, and physical safeguards to protect your information. However, no security system is impenetrable, and we cannot guarantee absolute security.",
      "You are responsible for maintaining the confidentiality of your account credentials and immediately notifying us of any unauthorized use of your account.",
    ],
  },
  {
    heading: "Your Choices",
    body: [
      "You may update your account details or preferences at any time through your profile settings.",
      "You can opt out of marketing emails by following the unsubscribe instructions in the messages. Note that you will still receive transactional or service-related communications.",
      "You may request deletion of your account by contacting us using the information provided below. We may retain certain data as required by law or for legitimate business purposes.",
    ],
  },
  {
    heading: "Children's Privacy",
    body: [
      "The Services are not intended for children under the age of 18. We do not knowingly collect personal information from anyone under 18. If we become aware that a child has provided personal data, we will take steps to delete such information.",
    ],
  },
  {
    heading: "International Data Transfers",
    body: [
      "Rentalo is based in India. By using the Services, you consent to the transfer and processing of your information in India and other jurisdictions where we or our service providers operate.",
    ],
  },
  {
    heading: "Changes to This Policy",
    body: [
      'We may update this Privacy Policy from time to time. When we do, we will revise the "Last updated" date at the top of this page. We encourage you to review the Policy periodically for any changes.',
    ],
  },
  {
    heading: "Contact Us",
    body: [
      "If you have questions or concerns about this Privacy Policy or our data practices, please contact us at privacy@rentalo.in or write to Rentalo, Bengaluru, Karnataka, India.",
    ],
  },
];

export default function Privacy() {
  return (
    <Container className="py-4">
      <Card className="shadow-sm border-0 rounded-4">
        <Card.Body>
          <h2 className="fw-bold text-gradient mb-3">Privacy Policy</h2>
          <p className="text-muted mb-4">Last updated: November 21, 2025</p>
          <div className="d-flex flex-column gap-4">
            {sections.map((section) => (
              <section key={section.heading}>
                <h5 className="fw-semibold mb-2">{section.heading}</h5>
                {section.body.map((paragraph, index) => (
                  <p key={index} className="text-secondary mb-2">
                    {paragraph}
                  </p>
                ))}
              </section>
            ))}
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
}
